import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import useSyncState from 'components/hooks/useSyncState';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import Ad from 'models/business/Ad';
import API from 'api';
import classNames from 'classnames';
import AdDetails from './AdDetails';
import AdSummary from './AdSummary';
import Styles from './index.module.css';

const useStyles = makeStyles({
  root: {
    background: 'transparent linear-gradient(180deg, #3D589B 0%, #273D76 100%) 0% 0% no-repeat padding-box',
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
  undone: {
    background: 'transparent linear-gradient(180deg, #75ACDC 0%, #689CC3 100%) 0% 0% no-repeat padding-box',
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
  archive: {
    background: 'transparent linear-gradient(180deg, #87898A 0%, #767B7B 100%) 0% 0% no-repeat padding-box',
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
  online: {
    background: 'transparent linear-gradient(180deg, #96C278 0%, #86AB6B 100%) 0% 0% no-repeat padding-box',
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
  pending: {
    background: 'transparent linear-gradient(180deg, #F6CA54 0%, #D9B350 100%) 0% 0% no-repeat padding-box',
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
  stopped: {
    background: 'transparent linear-gradient(180deg, #B0B3BB 0%, #9EA5A1 100%) 0% 0% no-repeat padding-box',
    boxShadow: '1px 1px 4px #00000065',
    borderRadius: '8px',
    opacity: 1,
  },
});

function GeneralAdCard({
  ad,
  amounts,
  onChangeAd,
}) {
  const [localAd, setLocalAd] = useSyncState(ad);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const classes = useStyles();
  const [useClasses] = useState(() => {
    switch (ad.status) {
      case 'Undone':
        return classes.undone;
      case 'Archive':
        return classes.archive;
      case 'Online':
        return classes.online;
      case 'Pending':
        return classes.pending;
      case 'Stopped':
        return classes.stopped;
      default:
        return classes.root;
    }
  });
  const collapsedIcon = useMemo(() => {
    if (isCollapsed) return <UnfoldLessIcon style={{ color: 'white' }} />;
    return <UnfoldMoreIcon style={{ color: 'white' }} />;
  }, [isCollapsed]);

  const onChange = () => setIsCollapsed(!isCollapsed);

  const handleChangeAd = async (newAd) => {
    setLoading(true);
    setError(false);
    const newAdJson = newAd.toJSON();
    // const result = await API.ad.postUpdateAd(newAdJson);
    const result = await API.ad.postUpdateAd2(newAdJson);
    if (result.errorMsg !== '0000') {
      setError(true);
      setLocalAd(new Ad(localAd));
    } else {
      setError(false);
      setLocalAd(newAd);
    }
    setLoading(false);
    onChangeAd(newAd);
  };

  return (
    <div
      className={classNames(
        Styles.mainContainer,
        {
          [Styles.mainContainerLoading]: loading,
          [Styles.mainContainerError]: error,
        },
      )}
    >
      <Accordion
        onChange={onChange}
        m={1}
        classes={{ root: useClasses }}
      >
        <AccordionSummary expandIcon={collapsedIcon} aria-controls="panel1c-content">
          <AdSummary ad={localAd} isCollapsed={isCollapsed} />
        </AccordionSummary>
        <AccordionDetails>
          <AdDetails
            ad={localAd}
            onChangeAd={handleChangeAd}
            amounts={amounts}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

GeneralAdCard.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  // eslint-disable-next-line react/forbid-prop-types
  amounts: PropTypes.object,
  onChangeAd: PropTypes.func,
};

GeneralAdCard.defaultProps = {
  ad: new Ad(),
  amounts: {},
  onChangeAd: () => {},
};

export default GeneralAdCard;
